const map = {
	"./img-manner-activity.svg": 3500,
	"./img-manner-baggage.svg": 9623,
	"./img-manner-drink.svg": 7307,
	"./img-manner-eating.svg": 4937,
	"./img-manner-fire.svg": 8739,
	"./img-manner-light.svg": 4685,
	"./img-manner-papers.svg": 2906,
	"./img-manner-pencil.svg": 5156,
	"./img-manner-pet.svg": 266,
	"./img-manner-photo.svg": 3473,
	"./img-manner-quietness.svg": 3528,
	"./img-manner-smoking.svg": 7547,
	"./img-manner-tel.svg": 2438,
	"./img-manner-touch.svg": 8120
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3608;